import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 10% 24px;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  margin-top: 20px;
`;
